import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { WagmiProvider } from 'wagmi';
import './index.css';
import AppDev from './AppDev';
import AppDemo from './AppDemo';
import { wagmiConfig } from './configs/wagmi';

const queryClient = new QueryClient();

// Entry point: mode "demo" (dev:demo / build:demo) -> AppDemo.tsx, otherwise -> AppDev.tsx. Uses Vite --mode only.
const isDemo = import.meta.env.MODE === 'demo';
const RootComponent = isDemo ? AppDemo : AppDev;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <WagmiProvider config={wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        <RootComponent />
      </QueryClientProvider>
    </WagmiProvider>
  </React.StrictMode>
);
